// Format currency to EUR
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

// Format date to German format (DD.MM.YYYY)
export const formatDate = (date) => {
  if (!date) return '';
  return new Intl.DateTimeFormat('de-DE').format(new Date(date));
};

// Format percentage
export const formatPercentage = (value) => {
  return new Intl.NumberFormat('de-DE', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value / 100);
};

// Format number
export const formatNumber = (value) => {
  return new Intl.NumberFormat('de-DE').format(value);
};
